const dict = {
  LANGUAGE_LABEL: {
    message: ' English',
  },
  MATRIX_DIMENSIONS_ERROR: {
    message: `Memory puzzle matrix must be at least 2x2 and maximum 10x10
    matrix dimension. For example:`,
  },
  LOADING: {
    message: 'Loading...',
  },
  ENTER_YOUR_NAME: {
    message: 'Enter your name',
  },
  PLAYERS_NAME: {
    message: 'Players name',
  },
  COLUMNS: {
    message: 'Columns',
  },
  ROWS: {
    message: 'Rows',
  },
  SELECT_LANGUAGE: {
    message: 'Select your langauge',
  },
  FULL_SCREEN: {
    message: 'Full screen',
  },
  APPLY: {
    message: 'Apply',
  },
  RESTART: {
    message: 'Restart',
  },
  PLAY: {
    message: 'Play',
  },
  CONTINUE: {
    message: 'Continue',
  },
  CHALLENGE: {
    message: 'Challenge',
  },
};

export default dict;
